import { IPraticaConvenzionato, ISegnalatorePromotore } from '@models/user.model';

/**
 * Dati mock per testare graficamente le liste delle pratiche promotore.
 * Struttura gerarchica a 3 livelli con almeno 15 elementi totali.
 */
export const MOCK_SEGNALATORI_PROMOTORE: ISegnalatorePromotore[] = [
  {
    id_segnalatore: 1001,
    denominazione: 'Marco Rossi - Promotore Senior',
    id_piano_marketing: 2,
    piano_marketing: 'Promotore',
    id_qualifica: 5,
    qualifica: 'Senior Manager',
    id_sponsor: 0,
    sponsor: '',
    livello: 1,
    pratiche: [
      {
        id_scheda: 10001,
        data_registrazione: ['2024-09-15'],
        id_stato: 3,
        stato: 'In Lavorazione',
        sequenza: 1,
        nominativo: 'Giovanni Bianchi',
        id_tipo_finanziamento: 1,
        tipo_finanziamento: 'Prestito Personale',
        perc_completamento: 85,
        esito_positivo: false,
        esito_negativo: false
      },
      {
        id_scheda: 10002,
        data_registrazione: ['2024-08-22'],
        id_stato: 5,
        stato: 'Completata',
        sequenza: 2,
        nominativo: 'Maria Verdi',
        id_tipo_finanziamento: 2,
        tipo_finanziamento: 'Mutuo Casa',
        perc_completamento: 100,
        esito_positivo: true,
        esito_negativo: false
      },
      {
        id_scheda: 10003,
        data_registrazione: ['2024-07-10'],
        id_stato: 2,
        stato: 'Rifiutata',
        sequenza: 3,
        nominativo: 'Luca Neri',
        id_tipo_finanziamento: 3,
        tipo_finanziamento: 'Cessione del Quinto',
        perc_completamento: 45,
        esito_positivo: false,
        esito_negativo: true
      }
    ],
    children: [
      {
        id_segnalatore: 2001,
        denominazione: 'Anna Ferrari - Agente',
        id_piano_marketing: 3,
        piano_marketing: 'Convenzionato Diretto',
        id_qualifica: 3,
        qualifica: 'Agente',
        id_sponsor: 1001,
        sponsor: 'Marco Rossi',
        livello: 2,
        pratiche: [
          {
            id_scheda: 20001,
            data_registrazione: ['2024-09-28'],
            id_stato: 1,
            stato: 'Bozza',
            sequenza: 1,
            nominativo: 'Francesco Russo',
            id_tipo_finanziamento: 1,
            tipo_finanziamento: 'Prestito Personale',
            perc_completamento: 30,
            esito_positivo: false,
            esito_negativo: false
          },
          {
            id_scheda: 20002,
            data_registrazione: ['2024-09-05'],
            id_stato: 5,
            stato: 'Completata',
            sequenza: 2,
            nominativo: 'Elena Colombo',
            id_tipo_finanziamento: 4,
            tipo_finanziamento: 'Leasing Auto',
            perc_completamento: 100,
            esito_positivo: true,
            esito_negativo: false
          }
        ],
        children: [
          {
            id_segnalatore: 3001,
            denominazione: 'Paolo Conti - Consulente',
            id_piano_marketing: 4,
            piano_marketing: 'Sub-agente',
            id_qualifica: 2,
            qualifica: 'Consulente Junior',
            id_sponsor: 2001,
            sponsor: 'Anna Ferrari',
            livello: 3,
            pratiche: [
              {
                id_scheda: 30001,
                data_registrazione: ['2024-10-01'],
                id_stato: 3,
                stato: 'In Lavorazione',
                sequenza: 1,
                nominativo: 'Simone Greco',
                id_tipo_finanziamento: 2,
                tipo_finanziamento: 'Mutuo Casa',
                perc_completamento: 65,
                esito_positivo: false,
                esito_negativo: false
              },
              {
                id_scheda: 30002,
                data_registrazione: ['2024-09-18'],
                id_stato: 2,
                stato: 'Rifiutata',
                sequenza: 2,
                nominativo: 'Claudia Marini',
                id_tipo_finanziamento: 1,
                tipo_finanziamento: 'Prestito Personale',
                perc_completamento: 55,
                esito_positivo: false,
                esito_negativo: true
              },
              {
                id_scheda: 30003,
                data_registrazione: ['2024-08-30'],
                id_stato: 5,
                stato: 'Completata',
                sequenza: 3,
                nominativo: 'Roberto Gallo',
                id_tipo_finanziamento: 3,
                tipo_finanziamento: 'Cessione del Quinto',
                perc_completamento: 100,
                esito_positivo: true,
                esito_negativo: false
              }
            ]
          },
          {
            id_segnalatore: 3002,
            denominazione: 'Giulia Romano - Consulente',
            id_piano_marketing: 4,
            piano_marketing: 'Sub-agente',
            id_qualifica: 2,
            qualifica: 'Consulente Junior',
            id_sponsor: 2001,
            sponsor: 'Anna Ferrari',
            livello: 3,
            pratiche: [
              {
                id_scheda: 30004,
                data_registrazione: ['2024-09-12'],
                id_stato: 3,
                stato: 'In Lavorazione',
                sequenza: 1,
                nominativo: 'Andrea Fontana',
                id_tipo_finanziamento: 5,
                tipo_finanziamento: 'Finanziamento Ristrutturazione',
                perc_completamento: 70,
                esito_positivo: false,
                esito_negativo: false
              }
            ]
          }
        ]
      },
      {
        id_segnalatore: 2002,
        denominazione: 'Stefano Bruno - Agente',
        id_piano_marketing: 3,
        piano_marketing: 'Convenzionato Diretto',
        id_qualifica: 3,
        qualifica: 'Agente',
        id_sponsor: 1001,
        sponsor: 'Marco Rossi',
        livello: 2,
        pratiche: [
          {
            id_scheda: 20003,
            data_registrazione: ['2024-09-20'],
            id_stato: 5,
            stato: 'Completata',
            sequenza: 1,
            nominativo: 'Valentina Serra',
            id_tipo_finanziamento: 1,
            tipo_finanziamento: 'Prestito Personale',
            perc_completamento: 100,
            esito_positivo: true,
            esito_negativo: false
          },
          {
            id_scheda: 20004,
            data_registrazione: ['2024-08-15'],
            id_stato: 2,
            stato: 'Rifiutata',
            sequenza: 2,
            nominativo: 'Marco Esposito',
            id_tipo_finanziamento: 2,
            tipo_finanziamento: 'Mutuo Casa',
            perc_completamento: 40,
            esito_positivo: false,
            esito_negativo: true
          }
        ],
        children: [
          {
            id_segnalatore: 3003,
            denominazione: 'Laura Ricci - Consulente',
            id_piano_marketing: 4,
            piano_marketing: 'Sub-agente',
            id_qualifica: 2,
            qualifica: 'Consulente Junior',
            id_sponsor: 2002,
            sponsor: 'Stefano Bruno',
            livello: 3,
            pratiche: [
              {
                id_scheda: 30005,
                data_registrazione: ['2024-10-05'],
                id_stato: 1,
                stato: 'Bozza',
                sequenza: 1,
                nominativo: 'Davide Moretti',
                id_tipo_finanziamento: 1,
                tipo_finanziamento: 'Prestito Personale',
                perc_completamento: 15,
                esito_positivo: false,
                esito_negativo: false
              },
              {
                id_scheda: 30006,
                data_registrazione: ['2024-09-25'],
                id_stato: 3,
                stato: 'In Lavorazione',
                sequenza: 2,
                nominativo: 'Silvia Barbieri',
                id_tipo_finanziamento: 4,
                tipo_finanziamento: 'Leasing Auto',
                perc_completamento: 75,
                esito_positivo: false,
                esito_negativo: false
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id_segnalatore: 1002,
    denominazione: 'Giuseppe Lombardi - Promotore Senior',
    id_piano_marketing: 2,
    piano_marketing: 'Promotore',
    id_qualifica: 5,
    qualifica: 'Senior Manager',
    id_sponsor: 0,
    sponsor: '',
    livello: 1,
    pratiche: [
      {
        id_scheda: 10004,
        data_registrazione: ['2024-09-08'],
        id_stato: 5,
        stato: 'Completata',
        sequenza: 1,
        nominativo: 'Federica Villa',
        id_tipo_finanziamento: 3,
        tipo_finanziamento: 'Cessione del Quinto',
        perc_completamento: 100,
        esito_positivo: true,
        esito_negativo: false
      },
      {
        id_scheda: 10005,
        data_registrazione: ['2024-08-28'],
        id_stato: 3,
        stato: 'In Lavorazione',
        sequenza: 2,
        nominativo: 'Matteo Pellegrini',
        id_tipo_finanziamento: 2,
        tipo_finanziamento: 'Mutuo Casa',
        perc_completamento: 60,
        esito_positivo: false,
        esito_negativo: false
      }
    ],
    children: [
      {
        id_segnalatore: 2003,
        denominazione: 'Chiara Martini - Agente',
        id_piano_marketing: 3,
        piano_marketing: 'Convenzionato Diretto',
        id_qualifica: 3,
        qualifica: 'Agente',
        id_sponsor: 1002,
        sponsor: 'Giuseppe Lombardi',
        livello: 2,
        pratiche: [
          {
            id_scheda: 20005,
            data_registrazione: ['2024-09-30'],
            id_stato: 2,
            stato: 'Rifiutata',
            sequenza: 1,
            nominativo: 'Alberto Caruso',
            id_tipo_finanziamento: 1,
            tipo_finanziamento: 'Prestito Personale',
            perc_completamento: 50,
            esito_positivo: false,
            esito_negativo: true
          },
          {
            id_scheda: 20006,
            data_registrazione: ['2024-09-14'],
            id_stato: 5,
            stato: 'Completata',
            sequenza: 2,
            nominativo: 'Beatrice Mancini',
            id_tipo_finanziamento: 5,
            tipo_finanziamento: 'Finanziamento Ristrutturazione',
            perc_completamento: 100,
            esito_positivo: true,
            esito_negativo: false
          },
          {
            id_scheda: 20007,
            data_registrazione: ['2024-08-20'],
            id_stato: 3,
            stato: 'In Lavorazione',
            sequenza: 3,
            nominativo: 'Cristiano De Luca',
            id_tipo_finanziamento: 4,
            tipo_finanziamento: 'Leasing Auto',
            perc_completamento: 80,
            esito_positivo: false,
            esito_negativo: false
          }
        ],
        children: [
          {
            id_segnalatore: 3004,
            denominazione: 'Alessia Battaglia - Consulente',
            id_piano_marketing: 4,
            piano_marketing: 'Sub-agente',
            id_qualifica: 2,
            qualifica: 'Consulente Junior',
            id_sponsor: 2003,
            sponsor: 'Chiara Martini',
            livello: 3,
            pratiche: [
              {
                id_scheda: 30007,
                data_registrazione: ['2024-10-02'],
                id_stato: 1,
                stato: 'Bozza',
                sequenza: 1,
                nominativo: 'Lorenzo Costa',
                id_tipo_finanziamento: 1,
                tipo_finanziamento: 'Prestito Personale',
                perc_completamento: 25,
                esito_positivo: false,
                esito_negativo: false
              },
              {
                id_scheda: 30008,
                data_registrazione: ['2024-09-22'],
                id_stato: 5,
                stato: 'Completata',
                sequenza: 2,
                nominativo: 'Martina Vitale',
                id_tipo_finanziamento: 3,
                tipo_finanziamento: 'Cessione del Quinto',
                perc_completamento: 100,
                esito_positivo: true,
                esito_negativo: false
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id_segnalatore: 1003,
    denominazione: 'Francesca Giordano - Promotore',
    id_piano_marketing: 2,
    piano_marketing: 'Promotore',
    id_qualifica: 4,
    qualifica: 'Manager',
    id_sponsor: 0,
    sponsor: '',
    livello: 1,
    pratiche: [
      {
        id_scheda: 10006,
        data_registrazione: ['2024-10-03'],
        id_stato: 3,
        stato: 'In Lavorazione',
        sequenza: 1,
        nominativo: 'Nicola Santoro',
        id_tipo_finanziamento: 2,
        tipo_finanziamento: 'Mutuo Casa',
        perc_completamento: 90,
        esito_positivo: false,
        esito_negativo: false
      },
      {
        id_scheda: 10007,
        data_registrazione: ['2024-09-17'],
        id_stato: 2,
        stato: 'Rifiutata',
        sequenza: 2,
        nominativo: 'Sara Ferrara',
        id_tipo_finanziamento: 1,
        tipo_finanziamento: 'Prestito Personale',
        perc_completamento: 35,
        esito_positivo: false,
        esito_negativo: true
      },
      {
        id_scheda: 10008,
        data_registrazione: ['2024-08-25'],
        id_stato: 5,
        stato: 'Completata',
        sequenza: 3,
        nominativo: 'Tommaso Messina',
        id_tipo_finanziamento: 4,
        tipo_finanziamento: 'Leasing Auto',
        perc_completamento: 100,
        esito_positivo: true,
        esito_negativo: false
      },
      {
        id_scheda: 10009,
        data_registrazione: ['2024-07-30'],
        id_stato: 5,
        stato: 'Completata',
        sequenza: 4,
        nominativo: 'Elisa Rinaldi',
        id_tipo_finanziamento: 5,
        tipo_finanziamento: 'Finanziamento Ristrutturazione',
        perc_completamento: 100,
        esito_positivo: true,
        esito_negativo: false
      }
    ],
    children: [
      {
        id_segnalatore: 2004,
        denominazione: 'Daniele Morrone - Agente',
        id_piano_marketing: 3,
        piano_marketing: 'Convenzionato Diretto',
        id_qualifica: 3,
        qualifica: 'Agente',
        id_sponsor: 1003,
        sponsor: 'Francesca Giordano',
        livello: 2,
        pratiche: [
          {
            id_scheda: 20008,
            data_registrazione: ['2024-10-04'],
            id_stato: 1,
            stato: 'Bozza',
            sequenza: 1,
            nominativo: 'Giorgia Pagano',
            id_tipo_finanziamento: 1,
            tipo_finanziamento: 'Prestito Personale',
            perc_completamento: 10,
            esito_positivo: false,
            esito_negativo: false
          },
          {
            id_scheda: 20009,
            data_registrazione: ['2024-09-27'],
            id_stato: 3,
            stato: 'In Lavorazione',
            sequenza: 2,
            nominativo: 'Riccardo Leone',
            id_tipo_finanziamento: 3,
            tipo_finanziamento: 'Cessione del Quinto',
            perc_completamento: 55,
            esito_positivo: false,
            esito_negativo: false
          }
        ],
        children: [
          {
            id_segnalatore: 3005,
            denominazione: 'Monica Fabbri - Consulente',
            id_piano_marketing: 4,
            piano_marketing: 'Sub-agente',
            id_qualifica: 2,
            qualifica: 'Consulente Junior',
            id_sponsor: 2004,
            sponsor: 'Daniele Morrone',
            livello: 3,
            pratiche: [
              {
                id_scheda: 30009,
                data_registrazione: ['2024-10-06'],
                id_stato: 3,
                stato: 'In Lavorazione',
                sequenza: 1,
                nominativo: 'Enrico Cattaneo',
                id_tipo_finanziamento: 2,
                tipo_finanziamento: 'Mutuo Casa',
                perc_completamento: 95,
                esito_positivo: false,
                esito_negativo: false
              },
              {
                id_scheda: 30010,
                data_registrazione: ['2024-09-19'],
                id_stato: 5,
                stato: 'Completata',
                sequenza: 2,
                nominativo: 'Isabella Ferretti',
                id_tipo_finanziamento: 1,
                tipo_finanziamento: 'Prestito Personale',
                perc_completamento: 100,
                esito_positivo: true,
                esito_negativo: false
              },
              {
                id_scheda: 30011,
                data_registrazione: ['2024-08-12'],
                id_stato: 2,
                stato: 'Rifiutata',
                sequenza: 3,
                nominativo: 'Gabriele Monti',
                id_tipo_finanziamento: 4,
                tipo_finanziamento: 'Leasing Auto',
                perc_completamento: 42,
                esito_positivo: false,
                esito_negativo: true
              }
            ]
          }
        ]
      }
    ]
  }
];

/**
 * Dati mock per testare graficamente le liste delle pratiche convenzionato.
 * Almeno 15 pratiche con mix di esiti diversi.
 */
export const MOCK_PRATICHE_CONVENZIONATO: IPraticaConvenzionato[] = [
  {
    id_scheda: 50001,
    data_registrazione: ['2024-10-01'],
    id_stato: 3,
    stato: 'In Lavorazione',
    sequenza: 1,
    nominativo: 'Antonio Rinaldi',
    id_tipo_finanziamento: 1,
    tipo_finanziamento: 'Prestito Personale',
    perc_completamento: 75,
    esito_positivo: false,
    esito_negativo: false
  },
  {
    id_scheda: 50002,
    data_registrazione: ['2024-09-28'],
    id_stato: 5,
    stato: 'Completata',
    sequenza: 2,
    nominativo: 'Carmela Basile',
    id_tipo_finanziamento: 2,
    tipo_finanziamento: 'Mutuo Casa',
    perc_completamento: 100,
    esito_positivo: true,
    esito_negativo: false
  },
  {
    id_scheda: 50003,
    data_registrazione: ['2024-09-25'],
    id_stato: 2,
    stato: 'Rifiutata',
    sequenza: 3,
    nominativo: 'Domenico Parisi',
    id_tipo_finanziamento: 3,
    tipo_finanziamento: 'Cessione del Quinto',
    perc_completamento: 38,
    esito_positivo: false,
    esito_negativo: true
  },
  {
    id_scheda: 50004,
    data_registrazione: ['2024-09-22'],
    id_stato: 3,
    stato: 'In Lavorazione',
    sequenza: 4,
    nominativo: 'Rossella Ferraro',
    id_tipo_finanziamento: 4,
    tipo_finanziamento: 'Leasing Auto',
    perc_completamento: 62,
    esito_positivo: false,
    esito_negativo: false
  },
  {
    id_scheda: 50005,
    data_registrazione: ['2024-09-20'],
    id_stato: 5,
    stato: 'Completata',
    sequenza: 5,
    nominativo: 'Vincenzo Marchetti',
    id_tipo_finanziamento: 5,
    tipo_finanziamento: 'Finanziamento Ristrutturazione',
    perc_completamento: 100,
    esito_positivo: true,
    esito_negativo: false
  },
  {
    id_scheda: 50006,
    data_registrazione: ['2024-09-18'],
    id_stato: 1,
    stato: 'Bozza',
    sequenza: 6,
    nominativo: 'Teresa Palmieri',
    id_tipo_finanziamento: 1,
    tipo_finanziamento: 'Prestito Personale',
    perc_completamento: 20,
    esito_positivo: false,
    esito_negativo: false
  },
  {
    id_scheda: 50007,
    data_registrazione: ['2024-09-15'],
    id_stato: 2,
    stato: 'Rifiutata',
    sequenza: 7,
    nominativo: 'Salvatore De Angelis',
    id_tipo_finanziamento: 2,
    tipo_finanziamento: 'Mutuo Casa',
    perc_completamento: 45,
    esito_positivo: false,
    esito_negativo: true
  },
  {
    id_scheda: 50008,
    data_registrazione: ['2024-09-12'],
    id_stato: 5,
    stato: 'Completata',
    sequenza: 8,
    nominativo: 'Giovanna Mariani',
    id_tipo_finanziamento: 3,
    tipo_finanziamento: 'Cessione del Quinto',
    perc_completamento: 100,
    esito_positivo: true,
    esito_negativo: false
  },
  {
    id_scheda: 50009,
    data_registrazione: ['2024-09-10'],
    id_stato: 3,
    stato: 'In Lavorazione',
    sequenza: 9,
    nominativo: 'Pasquale Orlando',
    id_tipo_finanziamento: 4,
    tipo_finanziamento: 'Leasing Auto',
    perc_completamento: 88,
    esito_positivo: false,
    esito_negativo: false
  },
  {
    id_scheda: 50010,
    data_registrazione: ['2024-09-08'],
    id_stato: 2,
    stato: 'Rifiutata',
    sequenza: 10,
    nominativo: 'Angela Giuliani',
    id_tipo_finanziamento: 1,
    tipo_finanziamento: 'Prestito Personale',
    perc_completamento: 52,
    esito_positivo: false,
    esito_negativo: true
  },
  {
    id_scheda: 50011,
    data_registrazione: ['2024-09-05'],
    id_stato: 5,
    stato: 'Completata',
    sequenza: 11,
    nominativo: 'Michele Vitali',
    id_tipo_finanziamento: 5,
    tipo_finanziamento: 'Finanziamento Ristrutturazione',
    perc_completamento: 100,
    esito_positivo: true,
    esito_negativo: false
  },
  {
    id_scheda: 50012,
    data_registrazione: ['2024-09-03'],
    id_stato: 3,
    stato: 'In Lavorazione',
    sequenza: 12,
    nominativo: 'Caterina Silvestri',
    id_tipo_finanziamento: 2,
    tipo_finanziamento: 'Mutuo Casa',
    perc_completamento: 70,
    esito_positivo: false,
    esito_negativo: false
  },
  {
    id_scheda: 50013,
    data_registrazione: ['2024-09-01'],
    id_stato: 1,
    stato: 'Bozza',
    sequenza: 13,
    nominativo: 'Raffaele Bernardi',
    id_tipo_finanziamento: 1,
    tipo_finanziamento: 'Prestito Personale',
    perc_completamento: 15,
    esito_positivo: false,
    esito_negativo: false
  },
  {
    id_scheda: 50014,
    data_registrazione: ['2024-08-29'],
    id_stato: 5,
    stato: 'Completata',
    sequenza: 14,
    nominativo: 'Luisa Testa',
    id_tipo_finanziamento: 3,
    tipo_finanziamento: 'Cessione del Quinto',
    perc_completamento: 100,
    esito_positivo: true,
    esito_negativo: false
  },
  {
    id_scheda: 50015,
    data_registrazione: ['2024-08-26'],
    id_stato: 2,
    stato: 'Rifiutata',
    sequenza: 15,
    nominativo: 'Fabio Riva',
    id_tipo_finanziamento: 4,
    tipo_finanziamento: 'Leasing Auto',
    perc_completamento: 48,
    esito_positivo: false,
    esito_negativo: true
  },
  {
    id_scheda: 50016,
    data_registrazione: ['2024-08-23'],
    id_stato: 3,
    stato: 'In Lavorazione',
    sequenza: 16,
    nominativo: 'Paola Longo',
    id_tipo_finanziamento: 5,
    tipo_finanziamento: 'Finanziamento Ristrutturazione',
    perc_completamento: 82,
    esito_positivo: false,
    esito_negativo: false
  },
  {
    id_scheda: 50017,
    data_registrazione: ['2024-08-20'],
    id_stato: 5,
    stato: 'Completata',
    sequenza: 17,
    nominativo: 'Emanuele Gentile',
    id_tipo_finanziamento: 1,
    tipo_finanziamento: 'Prestito Personale',
    perc_completamento: 100,
    esito_positivo: true,
    esito_negativo: false
  }
];

